// extracted by mini-css-extract-plugin
export default {"productGallery":"YJ-z","inQuickShop":"ZJ-z"};